import {
  createRootRoute,
  createRoute,
  createRouter,
  redirect,
} from '@tanstack/react-router';
import { RootLayout } from './pages/RootLayout';
import { DashboardPage } from './pages/Dashboard';
import { CostsPage } from './pages/Costs';
import { AutomationsPage } from './pages/Automations';
import { IntegrationsPage } from './pages/Integrations';
import { AlertsPage } from './pages/Alerts';
import { ArchivePage } from './pages/Archive';
import { AdminPage } from './pages/Admin';
import { AlertHistoryDetailPage } from './pages/AlertHistoryDetail';
import { WebAppsPage } from './pages/WebApps';
import { AuditLogPage } from './pages/AuditLog';
import { PlaceholderPage } from './pages/Placeholder';

const rootRoute = createRootRoute({ component: RootLayout });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});

const dashboardRoute = createRoute({ getParentRoute: () => rootRoute, path: '/dashboard', component: DashboardPage });
const costsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/costs', component: CostsPage });
const automationsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/automations', component: AutomationsPage });
const integrationsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/integrations', component: IntegrationsPage });
const alertsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/alerts', component: AlertsPage });

const alertHistoryDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/alerts/history/$id',
  component: function AlertHistoryDetail() {
    const { id } = alertHistoryDetailRoute.useParams();
    return <AlertHistoryDetailPage id={id} />;
  },
});

const archiveRoute = createRoute({ getParentRoute: () => rootRoute, path: '/archive', component: ArchivePage });
const adminRoute = createRoute({ getParentRoute: () => rootRoute, path: '/admin', component: AdminPage });

const auditLogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/audit-log',
  component: AuditLogPage,
});

// Placeholder routes — nav entries whose features are not yet built.
const webAppsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/web-apps',
  component: WebAppsPage,
});
const reportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reports',
  component: () => (
    <PlaceholderPage
      title="Reports"
      hint="Scheduled and on-demand operational reports are on the roadmap."
    />
  ),
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  dashboardRoute,
  costsRoute,
  automationsRoute,
  integrationsRoute,
  alertsRoute,
  alertHistoryDetailRoute,
  archiveRoute,
  adminRoute,
  auditLogRoute,
  webAppsRoute,
  reportsRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
